<p-toast key="order-bases-error-message" position="top-right"></p-toast>
<p-toast key="booking-summary" position="top-right"></p-toast>
<p-menu #menu [model]="actionMenu" appendTo="body" [popup]="true"></p-menu>
<p-confirmDialog [style]="{width: '50vw'}" acceptLabel="Current Page" rejectLabel="All Pages"
                 [breakpoints]="{'960px': '75vw', '640px': '100vw'}"
                 acceptIcon="pi pi-download"
                 [rejectIcon]="isFileDownloading ? 'pi pi-spin pi-spinner' : 'pi pi-download'"
                 [baseZIndex]="10000" acceptButtonStyleClass="p-button-secondary"
                 rejectButtonStyleClass="p-button-secondary"></p-confirmDialog>
<div>
    <!--    Start : Booking's Filter Component -->
    <div class="p-mt-3">
        <bookings-filter
                (emitFilterValue)="applyFilterToBookings($event)"></bookings-filter>
    </div>
    <!--    End : Booking's Filter Component -->

    <div>
        <div class="card height-100">
            <div class="p-d-block p-d-md-flex p-ai-center p-jc-between divider-bottom p-pb-4">
                <div>
                    <h5 class="p-m-0 p-text-primary">Booking Summary</h5>
                </div>
                <div class="p-d-flex pi-align-center p-mt-2 p-mt-md-0">
                    <div class="p-text-success">
                        Actual Time
                    </div>
                    <div class="p-text-warning p-ml-3">
                        Estimated Time
                    </div>
                    <div class="p-ml-3">
                        <img pRipple (click)="downloadFiles('pdf')" class="fp-icon-height p-cursor"
                             src="assets/branding/shared-icons/export-pdf.svg" alt="pdf-export">
                    </div>
                    <div class="p-ml-3">
                        <img pRipple (click)="downloadFiles('excel')" class="fp-icon-height p-cursor"
                             src="assets/branding/shared-icons/export-excel.svg"
                             alt="excel-export">
                    </div>
                </div>
            </div>

            <!--List & Card View Buttons-->
            <div *ngIf="filteredBookings?.content?.length !== 0 && !isLoading"
                 class="p-d-none p-d-md-flex p-ai-center p-jc-end p-mt-2 divider-bottom p-pb-2">
                <div class="p-text-bold p-ml-2">
                    <button pButton icon="pi pi-list" class="p-button-secondary"
                            (click)="selectedView = 0"
                            [class]="selectedView === 0 ? '' : 'p-button-text'"></button>
                </div>
                <div class="p-text-bold p-ml-2">
                    <button (click)="selectedView = 1" pButton icon="pi pi-id-card" class="p-button-secondary"
                            [class]="selectedView === 1 ? '' : 'p-button-text'"></button>
                </div>
            </div>

            <!--Spinner and No result Messages-->

            <div class="p-text-center">
                <div class="p-pt-5" *ngIf="isLoading" style="min-height: 20vw;">
                    <div>
                        <div class="p-text-secondary pi pi-spin pi-spinner"
                             style="font-size: 2rem"></div>
                    </div>
                    <div class="p-mt-4">
                        <h5 class="p-text-light">Loading Bookings !</h5>
                    </div>
                </div>

                <div class="p-pt-5" *ngIf="filteredBookings?.content?.length === 0 && !isLoading"
                     style="min-height: 20vw;">
                    <div>
                        <button pButton pRipple label="No Bookings Found !"
                                class="p-button-text p-text-secondary"></button>
                    </div>
                </div>
            </div>


            <!--Bookings Data listing and cards-->
            <div *ngIf="filteredBookings?.content?.length !== 0 && !isLoading">

                <!--Tab View for List and Cards-->
                <p-tabView styleClass="p-d-none p-d-md-block" [(activeIndex)]="selectedView">

                    <!--                    Start : Table View-->
                    <p-tabPanel>

                        <div class="p-d-none p-d-xl-block">
                            <p-table [value]="filteredBookings?.content" [scrollable]="true">
                                <!--                        'calc(78vh - 10.5rem)'-->
                                <ng-template pTemplate="header">
                                    <tr class="p-text-left width-100">
                                        <th pSortableColumn="shipmentType" class="p-py-3" style="width: 7%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Type
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="shipmentType"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th style="width: 12%">
                                            <div pSortableColumn="bookingId" class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Booking Number
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="bookingId"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="customerReferenceNumber" style="width: 13.75%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Customer Reference Number
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="customerReferenceNumber"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="transportDocument" style="width: 10.5%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div style="width: 55%">
                                                    Transport Document
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="transportDocument"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="bookingDate" style="width: 11.25%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Booking Date
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="bookingDate"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="origin" style="width: 8%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Origin
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="origin"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="departureDate" style="width: 9%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Departure
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="departureDate"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="destination" style="width: 9%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Destination
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="destination"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="arrivalDate" style="width: 9%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Arrival
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="arrivalDate"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th pSortableColumn="status" style="width: 12%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    Status
                                                </div>
                                                <div class="p-ml-2">
                                                    <p-sortIcon field="status"></p-sortIcon>
                                                </div>
                                            </div>
                                        </th>
                                        <th style="width: 3.25%;"></th>
                                    </tr>
                                </ng-template>

                                <ng-template pTemplate="body" let-booking>
                                    <tr class="p-text-left divider-bottom width-100">
                                        <td class="p-py-3" style="width: 7%">
                                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                                 class="p-d-flex p-ai-center width-100">
                                                <div [ngClass]="applyColorTextBaseOnType(booking?.shipmentType)">
                                                    {{booking?.shipmentType ? booking?.shipmentType : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td class="p-field-hover p-cursor" (click)="showShipmentDetails(booking)"
                                            style="width: 12%;">
                                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                                 class="p-d-flex p-ai-center width-100">
                                                <div class="p-text-bold">
                                                    {{booking?.bookingId ? booking?.bookingId : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 13.75%;">
                                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                                 class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    {{booking?.customerReferenceNumber ? booking?.customerReferenceNumber : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 10.5%">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                                     [style]="booking?.blCount > 0 ? 'width: 80%' : ''">
                                                    {{booking?.transportDocument ? booking?.transportDocument : '-'}}
                                                </div>
                                                <div class="p-ml-2" *ngIf="booking?.blCount > 0">
                                                    <p-badge [value]="booking?.blCount"></p-badge>
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 11.25%;">
                                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                                 class="p-d-flex p-ai-center width-100">
                                                <div>
                                                    {{booking?.bookingDate ? (booking?.bookingDate | date: 'dd-MMM-yyyy') : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 8%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                                    {{booking?.origin ? booking?.origin : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 9%;">
                                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                                 class="p-d-flex p-ai-center width-100">
                                                <div [class]="booking?.actualDepartureBoolean ? 'p-text-success' : 'p-text-warning'">
                                                    {{booking?.departureDate ? (booking?.departureDate | date: 'dd-MMM-yyyy') : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 9%;">
                                            <div class="p-d-flex p-ai-center width-100">
                                                <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'">
                                                    {{booking?.destination ? booking?.destination : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 9%;">
                                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                                 class="p-d-flex p-ai-center width-100">
                                                <div [class]="booking?.actualArrivalBoolean ? 'p-text-success' : 'p-text-warning'">
                                                    {{booking?.arrivalDate ? (booking?.arrivalDate | date: 'dd-MMM-yyyy') : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 12%;">
                                            <div [class]="platform.SAFARI ? 'p-text-wrap-safari ' : 'p-text-wrap'"
                                                 class="p-d-flex p-ai-center width-100">
                                                <div [class]="booking.status?.length > 0 ? 'rounded-normal white-color p-py-1 p-px-2 ' : ''"
                                                     [ngClass]="getColoredBookingStatus(booking?.status)">
                                                    {{booking?.status ? booking?.status : '-'}}
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 3.25%" class="p-text-right">
                                            <div class="p-ai-center p-jc-between">
                                                <i class="pi pi-ellipsis-v p-text-primary"
                                                   (click)="handleToggle(booking, $event)"
                                                   style="font-weight: bold; font-size: 1.65rem; cursor: pointer"></i>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>
                        </div>
                        <div class="p-d-block p-d-xl-none">
                            <booking-summary-tablet [filteredBookings]="filteredBookings"
                                                    (emitActions)="handleCardViewActions($event)"></booking-summary-tablet>
                        </div>
                    </p-tabPanel>
                    <!--                    End : Table View-->

                    <!--                    Start: Card View-->
                    <p-tabPanel>
                        <div class="p-grid">
                            <div class="p-col-12 p-md-6 p-lg-6 p-xl-4"
                                 *ngFor="let booking of filteredBookings?.content">
                                <booking-summary-mobile (emitActions)="handleCardViewActions($event)"
                                                        [booking]="booking"></booking-summary-mobile>
                            </div>
                        </div>
                    </p-tabPanel>
                    <!--                    End: Card View-->
                </p-tabView>

                <!--Start: Mobile View-->
                <div class="p-d-sm-block p-d-md-none">
                    <div class="p-grid">
                        <div class="p-col-12 p-md-6 p-lg-6 p-xl-4" *ngFor="let booking of filteredBookings?.content">
                            <booking-summary-mobile (emitActions)="handleCardViewActions($event)"
                                                    [booking]="booking"></booking-summary-mobile>
                        </div>
                    </div>
                </div>
                <!--End: Mobile View-->
            </div>
            <div>
                <p-paginator #pagination [totalRecords]="filteredBookings?.totalElements"
                             (onPageChange)="paginateFilteredBookings($event)" [rows]="10"></p-paginator>
            </div>
        </div>
    </div>
</div>
